module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page01"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("July 1816, Norfolk")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("The man in the mask ran one hand down the neck of the ugly gray hunter. ‘Patience, Tolly. One more to go and then it’s oats for you and two dozen of the finest old brandy for me.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The horse snorted, his ear flicking back to listen to his rider’s voice as Jonathan slouched into the familiar comfort of the saddle, eyes narrowed against the late-evening light. It was past eight now and no traffic had passed along the lane for half an hour. Up to then business had been brisk and last night’s wager seemed easily won. He dug a hand in his pocket and drew out the tokens he had claimed, proofs of a kiss from each of the first five women who passed down the lane on their way back from market in St. Margaret’s to the villages of Saint’s Mead and Saint’s Ford.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was a downy feather from the empty egg bucket of the country lass who had giggled and returned his kiss with relish; a tiny corn dolly from the elderly dame driving her donkey cart back, her baskets of straw plait almost empty, a twinkle in her eyes as she pinched his chin; a paper of pins from the thin-faced spinster who had blushed like a peony when he had respectfully saluted her papery cheek; and a promissory note for one ginger kitten (guaranteed of good mousing stock) from the farmer’s wife who had roared with laughter and tipped up her round red face with cheerful anticipation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jonathan pinned the corn dolly to his lapel, stuck the feather in his hat brim and wondered which of his housekeepers would most appreciate a kitten. His pleasure in the evening’s sport began to wane. He had another hour before he was due to join his friends at The Golden Lion for supper to present evidence of his success and the chances of the required fifth female happening along seemed increasingly poor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tolly lifted his head and pricked his ears. ‘Hoofbeats,’ Jonathan concurred. ‘One horse—likely to be a man.’ He nudged the gray through a gap in the thick hedgerow, drew the empty pistol, laid it along his thigh and waited.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("‘Despicable, hypocritical swine,’ Sarah Tatton repeated, reining in her mare to a walk and dashing the tears out of her eyes with an impatient hand. Careering around the countryside sidesaddle in evening dress was far from comfortable now that her initial fury had simmered down, to be replaced by something approaching panic.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How could she have been so meek, so trustingly innocent? Eighteen months sitting in the country, perfecting her wifely skills in domestic management, needlework and entertaining, while Papa boasted to all and sundry of the excellent match he had made for his daughter—and what had she to show for it? Her linen cupboard was immaculate, her stillroom a marvel, she could play a sonata and hold her own in the most trying dinner-party conversation and, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("finally")])]), _vm._v(", her betrothed had deigned to turn up to discuss the wedding.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sir Jeremy Peters might be only moderately good-looking and not possess a sparkling wit, but he was, as everyone had told her during the course of her second Season, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("a catch")])]), _vm._v(" for the daughter of a country baronet with moderate looks and a moderate dowry to match. Wealthy, well-connected—she could not hope to do better to oblige her papa.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Respectable?’ Sarah swore under her breath. Half an hour in his company, during which he had congratulated her on her modest gown and presented her with a hideous string of lumpy freshwater pearls had made her heart sink; she had not remembered him as being so dull. But when she had gone upstairs to change for dinner Mary, her maid, had broken down in floods of tears as she fastened her gown.")])])]), _c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’ve got to tell you, Miss Sarah. I cannot let you marry him, not even if it means my place,’ she had wailed. What Sarah had heard took her breath away and left her sick and shaken. Sir Jeremy had assaulted Mary at the house party where he had proposed to Sarah and threatened that he would tell Sir Hugh Tatton that she had offered herself for money if she said one word of it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So Sarah confronted her father with the fact that she had discovered her betrothed was the sort of man who would ravish defenseless young women—and Papa had dismissed the matter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Nonsense,’ he blustered, slapping his newspaper down on his desk in irritation. ‘Some young trollop looking to earn herself a few shillings, I’ve no doubt. Asking for it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘But no, Papa! This is a respectable girl.’ She did not dare tell him who, not with the memory of the housemaid turned off without a character when Cousin William’s visit had left her pregnant. Her father was of the old school when it came to domestic discipline. ‘And even if it were the case that she was willing, you cannot expect me to marry a man of such loose morals.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘A lady ignores such matters. It is her duty to remain faithful, above reproach, and to raise her children. Her husband may seek diversion elsewhere—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Diversion!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He scowled. ‘Diversion. It means nothing and no lady of refined mind should think of such things, let alone admit to knowing of them.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I cannot possibly marry Sir Jeremy,’ she announced flatly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You most certainly will, my girl! I’m not letting a good match like that slip through my fingers because of some missish scruples. You marry him—or I will find out who has been filling your head with this scurrilous nonsense and see they suffer for it. Do you understand me?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How could she find Mary a suitable new post, one where she would be safe from her father’s wrath? If she had been in London she could have gone to a good agency, given her glowing references, but here, deep in the country, such a plan would have to be conducted by letter and Papa insisted on her chaperone reading all her correspondence.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And how she was going to be able to keep a civil tongue in her head over dinner she had no idea. She had stood outside the drawing room gathering her composure to enter when she heard the men talking inside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Modest virtue, that is the thing about Miss Tatton,’ Sir Jeremy was saying. ‘The assurance that one is marrying a virgin of impeccable upbringing and not one of those flighty girls who live for nothing but their beaux and their parties. How precious is a lady’s purity! I searched long and hard before I was confident I had found such a prize.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The hypocrite valued only her "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("virginity")])]), _vm._v("? He debauched young women and yet he could say such things to her father who would smugly accept them?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sarah turned on her heel. ‘Tell Sir Hugh that I have a migraine and regret I will not be able to come down this evening,’ she said to the footman. The moment his back was turned she was away to the stables.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Leaving the house for an hour or so at least gave her a chance to cool her temper, but what to do now? Fear was beginning to overcome the fury as her imagination took hold, presenting her with a vivid image of what life with Sir Jeremy would be like. Her instinct was to run, but that was pointless; how would she live?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The question became academic as she rounded a corner and found herself staring down the barrel of a large horse pistol. ‘Stand and deliver.’")])])]), _c('a', {
    attrs: {
      "id": "page03"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A highwayman? They really said that? Sarah discovered her mouth was open and shut it. The figure confronting her was straight off any broadsheet telling the shocking stories of Dick Turpin or “Hell” Hawley. A big, ugly gray horse, a tricorne hat, a cloak thrown back over his shoulders despite the heat and a black mask covering the upper half his face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She dragged Sir Jeremy’s string of pearls over her head and held it out. He was welcome to them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, I don’t want those, sweetheart.’ His voice was amused, educated and deep; it seemed to resonate at the base of her spine. A gentleman gone to the bad?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("From somewhere she found her voice. ‘What do you want then?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘One kiss and a little token to show for it.’ He urged the horse up alongside her mare and she realized it was not just the horse that was big. She made herself sit still and not flinch away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And then she found she did not want to. ‘A kiss?’ He was clean-shaven, his teeth white as he smiled in the evening light. The breeze brought her not the rank smell of unwashed robber that she had been expecting, but the clean odors of leather and citrus. ‘It is not gallant to jest! You may have the pearls and welcome.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No.’ He took the pearls in an ungloved hand and dropped them back around her neck, holstered the pistol and leaned toward her, doffing his hat. ‘I do not jest.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His hair was dark brown, overlong, waving from the pressure of the hat. His eyes were green, shadowed by the mask, and yet when he smiled she could just see the laughter lines in the corners, the humor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Just one kiss?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He nodded as she bit her lip in indecision, his mouth curving in a way that made her want to touch it. ‘If you will grant it. I do not steal from women.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What if she should kick her heels and send the mare plunging past him? He leaned down and took the reins as though he could read her mind. Sarah stared at him, wondering why she did not scream. He really was a very strange highwayman. And she was in a very strange mood. She was conscious of her heartbeat—that was trepidation, no doubt—but what to make of the warm feeling low in her belly or the fact that her lips were dry? Sarah licked them and saw his eyes follow the movement.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Why have you a corn dolly in your buttonhole?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘A token from the donor of my second kiss. It is a fertility symbol, I believe, but don’t worry, kisses are harmless.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An interesting definition of harmless! ‘Very well. I have nothing better to be doing this evening, after all.’ She tipped up her face, turning her cheek toward him and closing her eyes. And then she felt his breath warm on her skin and realized he really was only going to take what she offered and some madness seized her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She opened her eyes and moved her head and met the hooded green gaze and his mouth found hers. ‘Oh!’ As she gasped his tongue slid between her lips and his free arm went around her shoulders and he lifted her against him so she was standing in the stirrup while the kiss went on…and on…and the warm evening world spun around her and his heat and the questing invasion of his tongue filled her senses and she gripped his lapels and touched her tongue to his and thought she would faint from the intensity of it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And then she was back in the saddle and they were looking at each other as though the earth had just shifted beneath them. He seemed to be breathing rather heavily. She rather thought that if she did not loosen her stay laces that breathing would no longer be possible.")])])]), _c('a', {
    attrs: {
      "id": "page04"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Madam,’ he said at last. ‘I must thank you for giving me the most precious thing in your possession. May I ask for a token, also?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sarah took hold of three or four hairs that had come down from her topknot of curls, tugged them free and held them out to him. He bowed slightly and curled them with care around the corn dolly. He thought her kiss precious? A highwayman’s opinion of her kiss was certainly more acceptable than Sir Jeremy’s hypocritical valuation of her virginity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Sir, that is not the most precious thing I possess.’ The words left her lips without conscious thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘It is not?’ The green eyes rested on her face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No. I am a virgin.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The gray tossed its head as though its rider had clenched his hand on the reins. ‘Ma’am?’ She saw him swallow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘And that is something of a burden to me, just now,’ she confessed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Indeed?’ He looked, not shocked, but interested.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Somehow the story tumbled out. How she came to be recounting such intimate details to a complete stranger, a man—a rogue—Sarah could not fathom. Why she was not sliding from Daisy’s back in a pool of embarrassment, she had no idea, but she did not even seem to be blushing. It could only be her desperation and the utter seriousness with which he was listening to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘In short,’ she concluded, ‘my father plans to marry me to a lecherous, hypocritical excuse for a gentleman for whom my only virtue appears to be my—well, my "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("virtue")])]), _vm._v(".’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘If you were not a virgin, he would not be interested,’ the highwayman remarked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, I am, so there’s nothing to be done about it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You could have a frank discussion with a married lady, discover some, er…details and inform your chaperone that you have lost your virtue, describing the experience so she had no doubts,’ he suggested in a matter-of-fact manner, as though they were puzzling over some trivial problem.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘There is no one I could talk to.’ If only her good friend Jessica was home from her honeymoon by now! She would enter into this scheme with complete frankness, but it would be another two weeks and that was too late. ‘I do not think that anything less than firsthand experience would do. I can hardly make it up. But thank you, it was a very good idea.’ She sighed, feeling the tears beginning to well up in her eyes again. She bit down hard on her lip to stop them; weeping and moaning was not going to get her out of this fix.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The gray backed away and she glanced up at its rider’s face. Below the mask his mouth was set. He looked somewhat grim. ‘I could help you.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Describe…"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("it")])]), _vm._v("?’ she faltered, finding she could blush, after all.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No. I doubt I could, from a woman’s point of view. No, more practically, we—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You want to take my virginity?’ Her voice emerged as a squeak. Daisy tossed her head, catching her mistress’s sudden panic.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, but I could "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("almost")])]), _vm._v(" take your virginity.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Almost.’ The light was beginning to fade and she was not able to make out the nuances of his expression beneath the mask. His tone was pitched somewhere between appalled and amused.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Almost. Just so you get the idea. Have you any knowledge of the theory, Miss, er…?’")])])]), _c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Sarah,’ she said shortly. ‘No, not much. I know it hurts and I know there is the danger of becoming pregnant and I have no desire for the former experience and certainly none for the latter.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I promise that neither would be the case.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Are you mad?’ she inquired, more of herself than of him. He did not appear to be deranged and if he was an evil seducer, he was certainly going about it in a most original way. And she was beginning to find the preposterous, shocking suggestion positively…possible.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I know you did not rob me just now, or ravish me,’ she said, frowning at him in the twilight. ‘And you could have done either, quite easily. I liked the way you kissed me, although I should not. You appear to be a man of principle, even if you do earn your living in an illegal manner.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shook his head, seeming to withdraw from the idea even as she became convinced. ‘You are right, I was mad to suggest it. There must be some other way out of your predicament.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sarah contemplated her situation. She was not lacking, she felt, in either determination or imagination, but she could see no other way out of this. ‘No, you are quite right: it is the perfect solution. And if you will not then I must find someone who will help me.’ There wasn’t anyone, of course, but she put every ounce of conviction she could muster into the statement.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Jonathan could feel his will being sapped by the intensity in the gray eyes fixed on his face. He believed she was in trouble, else why would she be riding alone in evening dress? She appeared to be in her right mind—which was more than he had been a moment ago as he had articulated, without thinking, the idea that had come to him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was an edge of desperation in her tone that convinced him that what she said of her betrothed was true and it was not simply a matter of a lovers’ quarrel. And now that he had put the idea into her mind he feared she really would seek out another man if he refused her. And then there was that kiss. The taste of her like honey and roses and a hint of spice and the heat and the response that he would swear was instinctive, innocent—and deadly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had no idea, of course, of what he would be letting himself in for. No concept of the willpower it would take to go so far and then stop, to pleasure her just so far and no further. ‘Very well.’ Her expression made him smile. Her eyes widened with surprise, relief and apprehension in almost equal measure. ‘I know an inn not far from here.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘The Golden Lion.’ She nodded. Of course, she must live hereabouts and know it. And be known, if only by sight. This would take some care.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He led her back along the woodland path he had come by, stopping at the shepherd’s hut he had noticed earlier. ‘We’ll leave your mare here. There is shelter and water.’ She let him lift her down, silk and light boning and warm, slender waist under his hands making his imagination run riot while he saw to the mare, conscious of Sarah’s eyes on his back as he worked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What is your name?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Jonathan. Here, take this.’ He swung off his cloak and tied it around her neck, flipping up the hood to cover hair and face, then boosted her up onto Tolly’s broad back and swung into the saddle behind her. Ah, more torture, the soft weight of her on his thighs, the little wriggle she gave to get her balance, the scent of her body pressed warm to his chest.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You are a successful highwayman then, Jonathan, to be able to afford The Golden Lion and yet resist my pearls?’")])])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Shall we say it is more of a recreation than a business?’ he suggested, guiding Tolly toward the stable yard, puzzling about the woman in his arms. Not just out, certainly. Twenty-two or-three, he would guess, with some authority about her. Well-bred, respectable and, presumably, an obedient daughter up to the point her father introduced this undesirable suitor. He had never seen her before, which meant she did not move in his circles, but even so, to avoid embarrassment he rather thought he would keep his mask on.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He helped her down in the shadows and led her up the side stairs and to his room without being seen. ‘Wait here. I’ll not be long.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His six friends were in the private parlor, cards on the table, bottles open, food spread out on the sideboard. They got to their feet, grinning, as he came in, still masked. ‘Well,’ Griffin demanded, ‘have I won back the money I lost on yesterday’s prizefight or am I out a dozen of my best cognac?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You’re out.’ Jonathan tossed his hat on the table. ‘Here—a feather from a maid who’d taken her eggs to market and came back with a kiss to spare for me, black hairs from a fancy young thing with her nose in the air, a corn dolly from an old duck in a donkey cart and a paper of pins from a severe dame who is doubtless still blushing. Oh yes, and the promise of a ginger kitten should I care to collect it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Damn me, I never thought you’d do it.’ Lord Gray splashed port into his glass and downed it in one gulp. ‘I wagered against you. Get some food and come and help me win it back.’ He gestured at the litter of vowels on the table.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, I’ll leave you to it.’ Jonathan walked over to the sideboard, rubbing his back. ‘Pulled a muscle somehow. Damn sore. I’ll take some food up and see if bed will put it to rights.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He retreated, with a laden plate and a wine bottle in his pocket, amid gibes about what had caused the strain and ribald suggestions for curing it.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Sarah perched on the edge of the bed and wondered if she had gone mad. If she had misjudged her man, she was in serious trouble. Even if she had not, she was deliberately setting out to ruin herself. And then there was the undeniable fact that she was about to commit acts of shocking intimacy with a man. A stranger.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What was almost more disturbing, she found her heart was beating with wild anticipation at the thought of it. She wanted him in almost equal measure to the fear. Her highwayman. Jonathan. She had never wanted a man before; at least she had never wanted more than a mild flirtation, a daring kiss to set her a-flutter for an evening, to be forgotten in the morning along with the champagne and the foolish flirting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now…She jumped as the door opened and he came in, locking it behind him. He handed her the key before putting a plate on the table and taking knife, fork and bottle from his pocket.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Food first?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That voice seemed to curl round inside her, making her hot and flustered and strangely jumpy. ‘No.’ "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Eat? Is he mad?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Wine, then?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes.’ That would help. She studied him as he eased out the cork. Long legs, broad shoulders, enough muscle to be a fighter and a smile on him that turned the hot, flustered feeling into a deep, disturbing, low ache. He still wore the mask and she was glad of it; somehow it made him less real. ‘Thank you.’ She gulped the wine and handed him back the glass. ‘I am a little nervous, I confess.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Understandably. Do you still want to go through with this?’ Sarah thought of Sir Jeremy, thought of Mary’s tears, and nodded. ‘We will proceed to the matter at hand then? Would you like to undress first, or shall I?’")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce5d88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/disrobedanddishonored_ch01.vue
// module id = 69
// module chunks = 0